const LEGACY_MAP = {
  ADMIN_USERS: ['ADMIN_USERS_READ', 'ADMIN_USERS_WRITE'],
  ADMIN_ORGS: ['ADMIN_ORGS_READ', 'ADMIN_ORGS_WRITE', 'ADMIN_ORG_APPROVE'],
};

/**
 * @param {string[] | undefined} permissions
 * @param {string} code
 */
export function hasPermission(permissions, code) {
  if (!permissions?.length) return false;
  if (permissions.includes(code)) return true;
  for (const [legacy, expanded] of Object.entries(LEGACY_MAP)) {
    if (permissions.includes(legacy) && expanded.includes(code)) return true;
  }
  return false;
}

/**
 * @param {import('../auth/AuthContext').User | null} user
 * @param {string | null | undefined} permission
 */
export function userHasPermission(user, permission) {
  if (!permission) return true;
  return hasPermission(user?.permissions, permission);
}

export const PERMISSIONS = {
  DASHBOARD_READ: 'ADMIN_DASHBOARD_READ',
  ORGS_READ: 'ADMIN_ORGS_READ',
  ORGS_WRITE: 'ADMIN_ORGS_WRITE',
  ORG_APPROVE: 'ADMIN_ORG_APPROVE',
  USERS_READ: 'ADMIN_USERS_READ',
  USERS_WRITE: 'ADMIN_USERS_WRITE',
  ROLES_WRITE: 'ADMIN_ROLES_WRITE',
  CONTRACTS_READ: 'ADMIN_CONTRACTS_READ',
  CATALOG_MODERATE: 'ADMIN_CATALOG_MODERATE',
  FINANCE_READ: 'ADMIN_FINANCE_READ',
  REFUND_WRITE: 'ADMIN_REFUND_WRITE',
  DISPUTES_MEDIATE: 'ADMIN_DISPUTES_MEDIATE',
  SUPPORT_WRITE: 'ADMIN_SUPPORT_WRITE',
  AUDIT_READ: 'ADMIN_AUDIT_READ',
  SETTINGS_WRITE: 'ADMIN_SETTINGS_WRITE',
  ANNOUNCE_WRITE: 'ADMIN_ANNOUNCE_WRITE',
  REPORTS_READ: 'ADMIN_REPORTS_READ',
};

/** Spec §3 permission catalog order */
export const PERMISSION_ORDER = [
  PERMISSIONS.DASHBOARD_READ,
  PERMISSIONS.ORGS_READ,
  PERMISSIONS.ORGS_WRITE,
  PERMISSIONS.ORG_APPROVE,
  PERMISSIONS.USERS_READ,
  PERMISSIONS.USERS_WRITE,
  PERMISSIONS.ROLES_WRITE,
  PERMISSIONS.CONTRACTS_READ,
  PERMISSIONS.CATALOG_MODERATE,
  PERMISSIONS.FINANCE_READ,
  PERMISSIONS.REFUND_WRITE,
  PERMISSIONS.DISPUTES_MEDIATE,
  PERMISSIONS.SUPPORT_WRITE,
  PERMISSIONS.AUDIT_READ,
  PERMISSIONS.SETTINGS_WRITE,
  PERMISSIONS.ANNOUNCE_WRITE,
  PERMISSIONS.REPORTS_READ,
];

/**
 * @param {Array<{ code?: string }>} items
 */
export function sortPermissions(items) {
  const orderIndex = new Map(PERMISSION_ORDER.map((code, index) => [code, index]));
  return [...items].sort((a, b) => {
    const aIndex = orderIndex.get(a.code) ?? Number.MAX_SAFE_INTEGER;
    const bIndex = orderIndex.get(b.code) ?? Number.MAX_SAFE_INTEGER;
    if (aIndex !== bIndex) return aIndex - bIndex;
    return (a.code || '').localeCompare(b.code || '');
  });
}
